// extracted by mini-css-extract-plugin
module.exports = {"team":"ResultTable_team__2BYGW","trophy_icon":"ResultTable_trophy_icon__3FTBm","table_row":"ResultTable_table_row__1U2w7"};